
<template>
  <div v-if="isOpen" class="cookie">
    <v-alert prominent type="info" color="rgb(24,48,90)" class="pt-0 pb-0 pl-5 pr-5">
      <v-row align="center">
        <v-col class="grow">
          <div class="alert-message">
            {{ message }}
          </div>
        </v-col>
        <v-col class="shrink d-flex justify-end" cols="12" md="3">
          <v-btn class="ma-2" color="primary" @click="accept">{{ buttonTextAccept }}</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'cookie-alert',
  props: {
    buttonTextAccept: {
      type: String,
      default: 'Accept'
    },
    message: {
      type: String,
      default:
        'Like most websites we use cookies to improve your experience. By use of this site we will assume your acceptance'
    },
    position: {
      type: String,
      default: 'bottom'
    }
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    containerPosition () {
      return `cookie--${this.position}`
    }
  },
  created () {
    if (!this.getGDPR() === true) {
      this.isOpen = true
    }
  },
  methods: {
    getGDPR () {
      return localStorage.getItem('cookie:accepted', true)
    },
    accept () {
      this.isOpen = false
      localStorage.setItem('cookie:accepted', true)
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'click-accept-cookie',
        eventLabel: 'Accept cookie'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cookie {
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 3%;
  max-width: 900px;
  @media(min-width: 960px) {
    margin: 0 20%;
  }
  &__link {
    color: #ffffff;
    text-decoration: underline;
    transition: all .25s;
    &:hover {
      text-decoration: none;
    }
  }
  .alert-message {
    font-size: 14px;
  }
}
</style>
